import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { EnvelopeState, EnvelopeStore } from './envelope.store';
import { AppStoreQuery } from '@core/state';
@Injectable({ providedIn: 'root' })
export class EnvelopeQuery extends QueryEntity<EnvelopeState> {
  constructor(protected store: EnvelopeStore, protected appStoreQuery: AppStoreQuery) {
    super(store);
  }
}
